import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import { coachingAPI } from 'api/coachingAPI';
import DeleteIcon from 'assets/images/delete.png';
import CloseIcon from 'assets/images/icon/CloseIcon';
import PlusIcon from 'assets/images/icon/PlusIcon';
import Remove from 'assets/images/icon/Remove';
import axios from 'axios';
import useGetCoachingData from 'hooks/useGetCoachingData';
import {
  cloneDeep,
  isEmpty,
} from 'lodash';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import {
    useRecoilState, useRecoilValue,
    useSetRecoilState,
} from 'recoil';
import {
    activeSubmit,
    fireSubmit, isAdmin, loading,
} from 'state';
import styled from 'styled-components';
import { Icon } from 'view/components';

import plus from '../../../../../assets/images/plus_s.png';
import * as assert from "assert";
import EyeIcon from "../../../../../assets/images/icon/EyeIcon";
import EyeOpen from "../../../../../assets/images/icon/EyeOpen";
import {fadeIn} from "../../../../../styled/StyledComponent";

interface StyledComponentProps {
    width?: string;
    display?: string;
    justifyContent?: string;
}
interface LearingMaterialProps {
    file?: any;
}

const TestimonialsData = {
    details: "",
    jobTitle: "",
    file: null,
    name: "",
};

const Testimonials: React.FC<LearingMaterialProps> = () => {
    const {
        state: { createId },
    } = useLocation();
    const navigate = useNavigate();
    const [loadingState, setLoadingState] = useRecoilState(loading)
    const admin = useRecoilValue(isAdmin)
    const setSubmit = useSetRecoilState(activeSubmit);
    const [coachingData, setCoachingData] = useState(null)
    const [submitFire, setSubmitFire] = useRecoilState(fireSubmit);
    const [homeworkTitle, setHomeworkTitle] = useState<string | undefined>();
    const [homeworkDetails, setHomeworkDetails] = useState<string | undefined>();
    const [homeworkCompletionTime, setHomeworkCompletionTime] = useState<string | undefined>();
    const [fileTitle, setfileTitle] = useState<string | undefined>();
    const [syllabusTitle, setSyllabusTitle] = useState("");
    const [practiceFiles, setPracticeFiles] = useState([{ fileName: "", file: null }]);
    const [uploadData, setUploadData] = useState([]);
    const [coaching, setCoaching] = useState([]);
    const syllabusFileInput = useRef(null);
    const homeworkFileInput = useRef(null);
    const [foldIndex, setFoldIndex] = useState([]);
    const [uploadFold, setUploadFold] = useState([])

    const onClickFoldChapter = (id?:any) => {
        const c = [...foldIndex];
        const check = c.findIndex(item => {
            return item === id;
        })
        if(check !== -1){
            c.splice(check,1);
        }else{
            c.push(id)
        }
        setFoldIndex(c);
    }
    const getCoachingData = async () => {
        await coachingAPI.getProductById(createId).then((res) => {
            console.log("coa data", res);
            if (!isEmpty(res?.data)) {

                setCoaching(cloneDeep(res?.data?.coaching?.testimonials));
                if(isEmpty(res?.data?.coaching?.testimonials) && isEmpty(uploadData)){
                    setUploadData([TestimonialsData])
                };
            }
        });
    };
    const getCoachingList = async () => {
        await coachingAPI
            .getCoachingList({
                params: {
                    progress:"IN_PROGRESS",
                },
            })
            .then((res) => {
                console.log("coa data", res);
                const c = cloneDeep(res?.content);
                const find = c.find(item => {
                    return item.id === createId
                })

                setCoaching(cloneDeep(find?.testimonials));
                if(isEmpty(find?.testimonials) && isEmpty(uploadData)){
                    setUploadData([TestimonialsData])
                };
            });
    };

    const getFormData = (practiceFiles) => {
        const syllabusFile = syllabusFileInput.current?.files?.[0];
        const homeworkFile = homeworkFileInput.current?.files?.[0];
        const formData = new FormData();
        // file
        if (syllabusFile) {
            const syllabusBlob = new Blob([syllabusFile], {
                type: syllabusFile.type,
            });
            formData.append("syllabusFile", syllabusBlob, syllabusFile.name);
        }
        if (homeworkFile) {
            const homeworkBlob = new Blob([homeworkFile], {
                type: homeworkFile.type,
            });
            formData.append("homeworkFile", homeworkBlob, homeworkFile.name);
        }
        console.log("object", practiceFiles);
        const copy = cloneDeep(practiceFiles);
        if (copy.length > 0) {
            console.log("copy.length", copy.length);
            copy.forEach((practiceFile) => {
                if (practiceFile.file) {
                    const practiceBlob = new Blob([practiceFile.file], {
                        type: practiceFile.file.type,
                    });
                    formData.append("practiceFile", practiceBlob, practiceFile.file.name);
                }
            });
        }

        // string
        homeworkTitle?.trim() && formData.append("title", homeworkTitle);
        homeworkDetails?.trim() && formData.append("homeworkDetails", homeworkDetails);
        homeworkCompletionTime && formData.append("expectedCompletionTime", homeworkCompletionTime);

        return formData;
    };

    const updateNoteData = (key, index, value, setState, state) => {
        const c = cloneDeep(state);
        c[index] = {
            ...c[index],
            [key]: value,
        };
        setState(cloneDeep(c));
    };

    const addNoteData = (isAdd = false, index?: number) => {
        const c = cloneDeep(uploadData);
        if (isAdd) {
            c.push(TestimonialsData);
        } else {
            c.splice(index, 1);
        }
        setUploadData(cloneDeep(c));
    };

    const stringData = () => {
        const formData = new FormData();
        homeworkTitle?.trim() && formData.append("title", homeworkTitle);
        homeworkDetails?.trim() && formData.append("homeworkDetails", homeworkDetails);
        homeworkCompletionTime && formData.append("expectedCompletionTime", homeworkCompletionTime);

        return formData;
    };

    const removePractiveFile = async (index) => {
        await classesAPI
            .deleteClassLearningMaterial(createId, {
                data: {
                    deleteHomeworkFile: false,
                    deleteSyllabusFile: false,
                    practiceFileOrder: [index],
                },
            })
            .then((res) => {
            });
    };

    const deleteSyllabus = async () => {
        await classesAPI
            .deleteClassLearningMaterial(createId, {
                data: {
                    deleteHomeworkFile: false,
                    deleteSyllabusFile: true,
                },
            })
            .then((res) => {
            });
    };

    const deleteHomework = async () => {
        await classesAPI
            .deleteClassLearningMaterial(createId, {
                data: {
                    deleteHomeworkFile: true,
                    deleteSyllabusFile: false,
                },
            })
            .then((res) => {
            });
    };

    const putLearningMaterial = async (practiceFiles, isString = false) => {
        await classesAPI
            .putClassLearningMaterial(createId, {
                data: isString ? stringData() : getFormData(practiceFiles),
                params:{
                    details:"",
                    jobTitle:""
                }
            })
            .then((res) => {
                console.log("suc", res);
            })
            .catch((e) => {
                console.log("failed", e);
            });
    };

    const handlePracticeFileList = (isAdd: boolean, index?: number) => {
        const copyData = cloneDeep(practiceFiles);
        if (isAdd === true) {
            copyData.push({ fileName: "", file: null });
            setPracticeFiles(cloneDeep(copyData));
        } else {
            copyData.splice(index, 1);
            setPracticeFiles(cloneDeep(copyData));
        }
    };

    const checkFileExtension = (fileName: string) => {
        const allowedExtensions =
            /(\.pdf|\.doc|\.docx|\.txt|\.rtf|\.html|\.csv|\.ppt|\.pptx|\.jpeg|\.png|\.gif)$/i;
        if (!allowedExtensions.exec(fileName)) {
            return false;
        }
        return true;
    };

    const isRightFileExtension = (file: any) => {
        const fileName = file?.name;
        if (!fileName) return false;

        const isRight = checkFileExtension(fileName);
        return isRight;
    };
    const handleAddHomeworkFile = () => {
        const file = homeworkFileInput.current?.files?.[0];
        if (!isRightFileExtension(file)) {
            alert("Please upload a file with the right extension");
            return;
        }
        putLearningMaterial(practiceFiles);
    };

    const handleAddSyllabusFile = () => {
        const file = syllabusFileInput.current?.files?.[0];
        if (!isRightFileExtension(file)) {
            alert("Please upload a file with the right extension");
            return;
        }
        setSyllabusTitle(file?.name);
        putLearningMaterial(practiceFiles);
    };
    console.log("syllabusTitle", syllabusTitle);

    const getNoteFormData = () => {
        const formData = new FormData();

        [...cloneDeep(uploadData), ]?.forEach((item,index) => {
            const fileBlob = new Blob([item?.file], {
                type: item?.file?.type,
            });
            formData.append(`notes[${index}].file`, fileBlob, item?.file?.name);
            formData.append(`notes[${index}].details`, item?.details);
            formData.append(`notes[${index}].jobTitle`, item?.jobTitle);
            formData.append(`notes[${index}].name`, item?.name);
        });        

        return formData;
    };
    
    console.log("@uploadData",uploadData);

    const getPatchFormData = () => {

    }

    const patchList = async () => {

        const c = cloneDeep(coaching)        
        ?.map(item => {
            const data = {
                id:item?.id,
                details:item?.details,
                name:item?.name,
                jobTitle:item?.jobTitle,
                multipartFile:item?.file
            }

            return cloneDeep(data);
        }); 

        c.forEach((item) => {
            const formData = new FormData();
            if(!isEmpty(item?.multipartFile?.name)){
                console.log("@item?.multipartFile?.name",item?.multipartFile?.name);
                const fileBlob = new Blob([item?.multipartFile], {
                    type: item?.multipartFile?.type,
                });
                formData.append("file", fileBlob, item?.multipartFile?.name)
            }
       
            formData.append("details", item?.details)
            formData.append("name", item?.name)
            formData.append("jobTitle", item?.jobTitle)

            patchTestimonialData(formData, item?.id);
        });
    };

    const patchTestimonialData = async (data, id) => {
        await coachingAPI.patchCoachingTestimonial(createId, id, {
            data: data,
        });
    };

    const putTestimonials = async () => {
        await coachingAPI.postCoachingTestimonials(createId, {
            data: getNoteFormData(),
        })
            .then(res => {
                getCoachingData();
                setUploadData([]);
                setLoadingState(v => !v)
            })
    };

    const onClickDelete = async (id) => {
        try{            
            await coachingAPI.deleteCoachingTestimonials(createId, id)
                .then(async res => {
                    await getCoachingData();
                });
        }catch(e){
            console.log('e', e)
        }finally{

        };
    };

    useEffect(() => {
        setSubmit(!isEmpty(syllabusTitle));
    }, [syllabusFileInput?.current?.value, syllabusTitle]);

    useEffect(() => {
        getCoachingData();
    }, []);

    console.log("coachingData 5", coachingData);
    console.log('uploadData', uploadData);
    console.log('coaching', coaching)
    console.log("@foldIndex",foldIndex);
    return (
        <Container>
            <Contents>
                <MainTitle>
                    <h2>What people say about you</h2>
                    <p>
                        Showcase your coaching expertise by including testimonials that highlight
                        your knowledge, insights and achievements.
                    </p>
                </MainTitle>
                <NotItemsWrap style={{minHeight:232}}>
                    {
                        !isEmpty(coaching) &&
                        coaching?.map((item, index) => {
                            return (
                                <NoteItems
                                    className={foldIndex.findIndex(foldItem => foldItem == item?.id) !== -1 ? "on" : ""}
                                >

                                    <h4>Note {index + 1}</h4>
                                    <Row display={"flex"} style={{marginBottom:7}}>
                                        <Col style={{width: "calc(100% / 2 - 8px)"}}>
                                            <FormBox>
                                                <dt>Name</dt>
                                                <dd>
                                                    <FormBoxItemWrap>
                                                        <li>
                                                            <FormItem>
                                                                <input
                                                                    type="text"
                                                                    value={item?.name}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        updateNoteData(
                                                                            "name",
                                                                            index,
                                                                            value,
                                                                            setCoaching,
                                                                            coaching
                                                                        );
                                                                    }}
                                                                    placeholder="Enters reviewer’s name"
                                                                />
                                                                <TextLength>50</TextLength>
                                                            </FormItem>
                                                        </li>
                                                    </FormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>
                                        <Col style={{width: "calc(100% / 2 - 8px)"}}>
                                            <FormBox
                                                className={"jobTitle"}
                                            >
                                                <dt>Job Title</dt>
                                                <dd>
                                                    <FormBoxItemWrap>
                                                        <li>
                                                            <FormItem>
                                                                <input
                                                                    type="text"
                                                                    value={item?.jobTitle}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        updateNoteData(
                                                                            "jobTitle",
                                                                            index,
                                                                            value,
                                                                            setCoaching,
                                                                            coaching
                                                                        );
                                                                    }}
                                                                    placeholder="Enters reviewer’s occupation"
                                                                />
                                                                <TextLength>50</TextLength>
                                                            </FormItem>
                                                        </li>
                                                    </FormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>
                                    </Row>
                                    <dt style={{color: "#333", opacity: 0.8}}>Photo (Optional)</dt>
                                    <VideoItems style={{marginTop: 10, alignItems: "center"}}>
                                        <FormItem style={{width: "100%", marginRight: 15}}>
                                            {!isEmpty(item?.file?.name) || item?.photo?.fileName !== "blob" && item?.photo?.fileName !== "" ? (
                                                <EditArea
                                                    style={{transform: "translateY(-23px)"}}>
                                                    <span>{!isEmpty(item?.file?.name) ? item?.file?.name : (item?.photo?.fileName)}</span>
                                                    <div className="delete" onClick={async () => {
                                                        const c = cloneDeep(coaching);
                                                        if (item?.file) {
                                                            c[index].file = null;
                                                        }
                                                        c[index].photo.fileName = "";
                                                        setCoaching(c);
                                                    }}>
                                                        <Icon width={16} height={16} icon={DeleteIcon}/>
                                                    </div>
                                                </EditArea>
                                            ) : (
                                                <input
                                                    // value={item.title}
                                                    value={""}
                                                    readOnly={true}
                                                    type="text"
                                                    placeholder="Upload reviewer’s picture"
                                                />
                                            )}
                                        </FormItem>

                                        <Browse
                                            className={"browse"}
                                            style={{marginRight: practiceFiles.length === 1 ? 0 : 15}}
                                        >
                                            <PlusIcon/>
                                            <span>Browse</span>
                                            <input
                                                type="file"
                                                onChange={async (e) => {
                                                    const value = e.target.files[0];
                                                    updateNoteData("file", index, value, setCoaching, coaching);
                                                    e.target.value = "";
                                                }}
                                            />
                                        </Browse>
                                        {practiceFiles?.length !== 1 && (
                                            <RemoveButton
                                                style={{
                                                    opacity: practiceFiles.length === 1 ? 0 : 1,
                                                    pointerEvents:
                                                        practiceFiles.length === 1 ? "none" : "all",
                                                }}
                                                onClick={async () => {
                                                }}
                                            >
                                                <Remove/>
                                            </RemoveButton>
                                        )}
                                    </VideoItems>

                                    <Row style={{marginBottom: 0}}>
                                        <FormBox
                                            className={"details"}
                                        >
                                            <dt>Details</dt>
                                            <dd>
                                                <FormBoxItemWrap>
                                                    <li>
                                                        <FormItem style={{width: "calc(100%)"}}>
                                                        <textarea
                                                            style={{height: 100}}
                                                            placeholder="Share detailed reviews and examples to help your students learn more about your coaching"
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                updateNoteData("details", index, value, setCoaching, coaching);
                                                            }}
                                                            value={item?.details}
                                                        />
                                                            <TextLength>
                                                                {1000 - item?.details?.length || 1000}
                                                            </TextLength>
                                                        </FormItem>
                                                    </li>
                                                </FormBoxItemWrap>
                                            </dd>
                                        </FormBox>
                                    </Row>

                                    <CloseButton onClick={() => {
                                        onClickDelete(item?.id);
                                    }}>
                                        <CloseIcon/>
                                    </CloseButton>
                                    <CloseButton
                                        onClick={()=>{
                                            onClickFoldChapter(item?.id)
                                        }}
                                        className={"eye"}
                                    >
                                        {
                                            foldIndex.findIndex(foldItem => foldItem == item?.id) !== -1 ? <EyeIcon/> : <EyeOpen/>
                                        }
                                    </CloseButton>

                                </NoteItems>
                            );
                        })
                    }

                    {
                        !isEmpty(uploadData) &&
                        uploadData?.map((item, index) => {
                            return (
                                <NoteItems
                                    className={uploadFold.findIndex(foldItem => foldItem == index) !== -1 ? "on" : ""}
                                >
                                    <h4>Note {coaching?.length + index + 1}</h4>
                                    <Row display={"flex"}>
                                        <Col style={{width: "calc(100% / 2 - 8px)"}}>
                                            <FormBox>
                                                <dt>Name</dt>
                                                <dd>
                                                    <FormBoxItemWrap>
                                                        <li>
                                                            <FormItem>
                                                                <input
                                                                    type="text"
                                                                    value={item?.name}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        updateNoteData(
                                                                            "name",
                                                                            index,
                                                                            value,
                                                                            setUploadData,
                                                                            uploadData
                                                                        );
                                                                    }}
                                                                    placeholder="Enters reviewer’s name"
                                                                />
                                                                <TextLength>50</TextLength>
                                                            </FormItem>
                                                        </li>
                                                    </FormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>
                                        <Col style={{width: "calc(100% / 2 - 8px)"}}>
                                            <FormBox
                                                className={"jobTitle"}
                                            >
                                                <dt>Job Title</dt>
                                                <dd>
                                                    <FormBoxItemWrap>
                                                        <li>
                                                            <FormItem>
                                                                <input
                                                                    type="text"
                                                                    value={item?.jobTitle}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        updateNoteData(
                                                                            "jobTitle",
                                                                            index,
                                                                            value,
                                                                            setUploadData,
                                                                            uploadData
                                                                        );
                                                                    }}
                                                                    placeholder="Enters reviewer’s occupation"
                                                                />
                                                                <TextLength>50</TextLength>
                                                            </FormItem>
                                                        </li>
                                                    </FormBoxItemWrap>
                                                </dd>
                                            </FormBox>
                                        </Col>
                                    </Row>
                                    <dt style={{color:"#333", opacity:0.8}}>Photo (Optional)</dt>

                                    <VideoItems style={{marginTop: 15, alignItems: "center"}}>
                                        <FormItem

                                            style={{width: "100%", marginRight: 15}}>
                                            {!isEmpty(uploadData[index]?.file?.name) && item?.photo?.fileName !== "" ? (
                                                <EditArea style={{transform: "translateY(-23px)"}}>
                                                    <span>{uploadData[index]?.file?.name}</span>
                                                    <div className="delete" onClick={async () => {
                                                        const c = cloneDeep(uploadData);
                                                        c[index].file = null;
                                                        setUploadData(c);
                                                    }}>
                                                        <Icon width={16} height={16} icon={DeleteIcon}/>
                                                    </div>
                                                </EditArea>
                                            ) : (
                                                <input
                                                    // value={item.title}
                                                    value={""}
                                                    readOnly={true}
                                                    type="text"
                                                    placeholder="Upload reviewer’s picture"
                                                />
                                            )}
                                        </FormItem>

                                        <Browse
                                            className={"browse"}
                                            style={{marginRight: practiceFiles.length === 1 ? 0 : 15}}
                                        >
                                            <PlusIcon />
                                            <span>Browse</span>
                                            <input
                                                type="file"
                                                onChange={async (e) => {
                                                    const value = e.target.files[0];
                                                    updateNoteData("file", index, value, setUploadData, uploadData);
                                                    setfileTitle(value?.name);
                                                    e.target.value = "";
                                                }}
                                            />
                                        </Browse>
                                        {practiceFiles?.length !== 1 && (
                                            <RemoveButton
                                                style={{
                                                    opacity: practiceFiles.length === 1 ? 0 : 1,
                                                    pointerEvents:
                                                        practiceFiles.length === 1 ? "none" : "all",
                                                }}
                                                onClick={async () => {
                                                }}
                                            >
                                                <Remove/>
                                            </RemoveButton>
                                        )}
                                    </VideoItems>

                                    <Row style={{marginBottom: 0}}>
                                        <FormBox
                                            className={"details"}
                                        >
                                            <dt>Details</dt>
                                            <dd>
                                                <FormBoxItemWrap>
                                                    <li>
                                                        <FormItem style={{width: "calc(100%)"}}>
                                                    <textarea
                                                        style={{height: 100}}
                                                        placeholder="Share detailed reviews and examples to help your students learn more about your coaching"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            updateNoteData("details", index, value, setUploadData, uploadData);
                                                        }}
                                                        value={item?.details}
                                                    />
                                                            <TextLength>
                                                                {1000 - item?.details?.length || 1000}
                                                            </TextLength>
                                                        </FormItem>
                                                    </li>
                                                </FormBoxItemWrap>
                                            </dd>
                                        </FormBox>
                                    </Row>
                                    <CloseButton
                                        onClick={()=>{
                                            const c = [...uploadFold];
                                            const check = c.findIndex(item => {
                                                return item === index;
                                            })
                                            if(check !== -1){
                                                c.splice(check,1);
                                            }else{
                                                c.push(index)
                                            }
                                            setUploadFold(c);
                                        }}
                                        className={"eye"}
                                    >
                                        {
                                            uploadFold.findIndex(foldItem => foldItem == index) !== -1 ? <EyeIcon/> : <EyeOpen/>
                                        }
                                    </CloseButton>
                                    {
                                        !isEmpty([...coaching, ...uploadData]) &&
                                        <CloseButton onClick={() => {
                                            addNoteData(false, index)
                                        }}>
                                            <CloseIcon/>
                                        </CloseButton>
                                    }
                                </NoteItems>
                            );
                        })}

                    <BtnWrap>
                        {
                            uploadData?.length + coaching?.length !== 8 &&
                            <AddChapter
                                onClick={() => {
                                    addNoteData(true);
                                }}
                            >
                                <PlusIcon />
                                <span>Add more</span>
                            </AddChapter>
                        }

                    </BtnWrap>
                </NotItemsWrap>


            </Contents>
            <Divider />

            <ButtonItems justifyContent={"flex-end"}>
                <Browse
                    className={"prev"}
                    style={{ marginRight: 15, width: 100, height: 40 }}>
                    <span style={{ marginLeft: 0 }}>Previous</span>
                </Browse>
                <button
                    className={"on continue"}
                    onClick={() => {
                        patchList()
                            .then(res => {
                                console.log("@res",res);
                                if(!isEmpty(uploadData)){
                                    putTestimonials()

                                };
                            })
                    }}
                >
                    Continue
                </button>
            </ButtonItems>
        </Container>
    );
};
export default Testimonials;

const Container = styled.div`
    animation: ${fadeIn} 0.5s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */

    //overflow-y: scroll;
    //scrollbar-width: thin;
    //scrollbar-color: transparent transparent;
    //
    //&::-webkit-scrollbar {
    //    width: 0;
    //}
    //
    //&::-webkit-scrollbar-thumb {
    //    background-color: transparent;
    //}
`;

const Contents = styled.div`
    padding: 20px 20px 0px 20px;
    overflow: hidden;
    //height: 500px;
    //overflow-y: scroll;
    position: relative;
`;

const MainTitle = styled.div`
    h2 {
        font-family: "Europa-Regular";
        font-size: 26px;
        font-weight: 700;
        line-height: 26px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 15px;
        color: #333;
    }
    p {
        font-family: Europa-Regular;
        margin-bottom: 15px;
        font-size: 18px;
        font-weight: 400;
        letter-spacing: 0em;
        text-align: left;
        color: #333;
        font-style: normal;
        line-height: 26px;
    }
`;
const NotItemsWrap = styled.div`
    border: solid 0.6px #33333399;
    box-shadow: 0px 0px 6px 0px #33333329;
    border-radius: 15px;
    overflow: hidden;
    margin-bottom: 20px;
    transition: all 0.2s;
    animation: ${fadeIn} 0.4s linear;
    & > div{
        &:nth-child(1){
            border: none;
            background: none;
        }
    }
`
const NoteItems = styled.div`
    color: #333!important;
    //border-top: solid 0.6px #33333399;
    //border-radius: 15px;
    transition: all 0.2s;
    
    background-image: url("/images/dashed-line.png");
    background-repeat: no-repeat;
    background-size: contain;
    padding: 15px;
    //margin-bottom: 20px;
    position: relative;
    overflow: hidden;
    height: 148px;
    @media screen and (max-width: 768px) {
        height: 160px;
    }
    &.on{
        height: 390px;
        @media screen and (max-width: 768px) {
            height: 580px;
        }
    }
    h4 {
        margin-bottom: 15px;
        font-family: Europa-Bold;
        font-size: 22px;
        font-weight: 700;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
    }
`;

const Row = styled.div<StyledComponentProps>`
    display: ${(props) => props.display};
    justify-content: space-between;
    margin-bottom: 15px;
    @media screen and (max-width: 768px) {
        flex-direction: column;
    }
`;
const Col = styled.div<StyledComponentProps>`
    width: calc((100% - 18px) / 2);
    @media screen and (max-width: 768px) {
        width: 100%!important;
    }
`;
const Divider = styled.div`
    width: calc(100%);
  
    height: 0.6px;
    background: #333;
    opacity: 0.3;
`;
const FormBox = styled.dl`
    @media screen and (max-width: 768px) {
        margin-top: 15px!important;
        &.details{
            padding-top: 15px;
        }
    }
 
    > dt {
        font-size: 16px;
        font-weight: 400;
        color: #333;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        > strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
`;
const FormBoxItemWrap = styled.ul`
    > li {
        font-size: 16px;
        margin: 8px 0;
    }
`;
const FormItem = styled.div`
    position: relative;
    transition: all 0.2s;
    @media screen and (max-width: 768px) {
        margin-right: 0!important;
    }
        h2 {
        font-size: 14px;
        margin-bottom: 15px;
    }
    .guide {
        pointer-events: none;
    }

    > input[type="text"],
    select,
    textarea {
        transition: all 0.2s;
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);
        padding: 12px 16px;
        &::placeholder {
            color: #ddd;
        }
    }
    > input[type="text"] {
        height: 48px;
        transition: all 0.2s;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
`;

const EditArea = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    border: solid 1px #33333360;
    z-index: 2;
    border-radius: 8px;
    padding: 0 15px;
    height: 48px;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    @media screen and (max-width: 768px) {
        position: relative;
        transform: none!important;
    }
    .delete {
        cursor: pointer;
        padding: 0 8px 2px 8px;
    }
    span {
        color: #333;
    }
`;

const TextLength = styled.span`
    color: rgba(51, 51, 51, 0.6);
    font-weight: 700;
    position: absolute;
    right: 16px;
    top: 17px;
`;

const SelectArrow = styled.div`
    position: absolute;
    right: 16px;
    top: 15px;
`;

const ThumbnailWrap = styled.div`
    color: #333;
    font-size: 16px;
`;

const ThumbnailTitle = styled.h5`
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
    > strong {
        font-size: 13px;
        font-weight: 600;
        color: #da1414;
        display: inline-block;
        margin-left: 1px;
        vertical-align: top;
    }
`;

const ThumbnailText = styled.p`
    margin-bottom: 15px;
    line-height: 22px;
`;

const ThumbnailUpload = styled.div`
    width: 100%;
    height: 180px;
    padding: 9px 8px;
    border: 1px dashed rgba(51, 51, 51, 0.6);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
        padding: 0;
        border: 0;
        background: none;
        line-height: 0;
        cursor: pointer;
    }
`;

const ThumbnailView = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &::after {
        width: 100%;
        height: 100%;
        position: absolute;
        background: #000;
        opacity: 0.5;
        content: "";
    }
`;

const ThumbnailButtonList = styled.ul`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    > li {
        margin: 0 4px;
    }
`;

const ThumbnailUploadButton = styled.button`
    width: 100%;
    height: 100%;
    > span {
        display: block;
        font-size: 18px;
        font-family: Europa-Regular;
        margin-top: 10px;
        line-height: 100%;
    }
`;

const ButtonItems = styled.div<StyledComponentProps>`
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    button {
        transition: all 0.2s;
        width: 100px;
        height: 40px;
        border: 0;
        cursor: pointer;
        padding: 11px 15px 11px 14px;
        color: #333;
        border-radius: 6px;
        background: #e5e5e5;
        &.on {
            background: #ddc160;
            color: #fff;
        }
    }
`;

const FormItems = styled.div`
    border: solid 1px #33333360;
    border-radius: 15px;
    overflow: hidden;
`;
const FormInner = styled.div`
    padding: 15px 15px 10px 15px;
    position: relative;
`;
const FormItemDivider = styled.div`
    width: 100%;
    height: 1px;
    background: #33333360;
`;
const VideoItemsWrap = styled.div`
    padding: 30px 15px 20px 15px;
    h2 {
        color: "#000";
        margin-bottom: 3px;
        font-size: 16px;
        font-weight: 400;
    }
`;
const VideoItems = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 15px;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        .form{
            margin-right: 0!important;
        }
        .browse{
            width: 100% !important;
            min-width: 100%;
            max-width: 100%;
            height: 48px;
            min-height: 48px;
            margin-top: 8px;
        }
    }
`;
const CheckBox = styled.div`
    display: flex;
    margin-right: 13px;
    align-items: center;
    span {
        padding-top: 2px;
        font-size: 16px;
        color: #212529;
    }
    div {
        margin-right: 8px;
        width: 16px;
        height: 16px;
        border-radius: 4px;
        border: solid 1px #333;
    }
`;
const Browse = styled.div`
    height: 48px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;
    flex: 1;
    width: 100%;
    min-width: 120px;
    max-width: 120px;
    position: relative;
    cursor: pointer;
    transition: all 0.2s;
    &.browse{
        svg{
            width: 16px;
            height: 16px;
        }
    }
    svg{
        
        path{
            fill: #333
        }
    }
    &:hover{
        background: #333;
        span{
            color: #fff;
        }
        svg{
            path{
                fill: #fff!important;
            }
        }
    }
    &.prev{
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        padding: 0!important;
    }
    span {
        margin-left: 10px;
    }
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    input {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #333;
        opacity: 0;
        z-index: 3;
    }
    a {
        border: solid 1px #111;
        position: absolute;
        width: 100%;
        height: 100%;
        background: #ddd;
        display: flex;
        opacity: 0;
    }
`;
const CloseButton = styled.div`
    background: #333;
    position: absolute;
    right: 0;
    top: 0;
    width: 51px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  
    &.eye{
        right: 50%;
        transform: translateX(50%);
        svg{
            path{
                fill: #fff;
            }
        }
    }
`;
const RemoveButton = styled.div``;

const AddButton = styled.div`
    height: 48px;
    border-radius: 8px;
    padding: 0 18.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;

    width: 129px;
`;

const BtnWrap = styled.div`
    width: 100%;
    border-top: 1px solid rgba(51, 51, 51, 0.3);
    display: flex;
    justify-content: flex-end;
    //position: sticky;
    z-index: 9;
    bottom: 10px;
    left: 100%;
    background: none;
    padding: 20px 15px 27px 15px;
`;

const AddChapter = styled.div`
    background: #333;
    display: flex;
    align-items: center;
    max-width: 160px;
    min-width: 160px;
    padding: 10px;
    justify-content: center;
    border-radius: 5px;
    transition: all 0.2s;
    border: solid 1px #333;
    svg{
        path{
            fill: #fff
        }
    }
    &:hover{
        background: #fff;
        span{
            color: #333;
        }
        svg{
            path{
                fill: #333!important;
            }
        }
    }
    cursor: pointer;
    svg {
        margin-right: 10px;
    }
    span {
        color: #fff;
        font-size: 18px;
        //padding-top: 3px;
        font-weight: 400;
        
    }
`;

const Transcript = styled.div`
    h3 {
        margin-top: 20px;
        margin-bottom: 14px;
        font-size: 26px;
        font-weight: 700;
    }
`;
